var map = {
	"./all.png": "1be4e",
	"./base.png": "6a28",
	"./black.png": "9bcd",
	"./fullart.png": "8e52",
	"./gold.png": "da66",
	"./monochrome.png": "a5ac",
	"./pink.png": "3bc9",
	"./promo.png": "4643",
	"./rainbow.png": "6c77",
	"./red.png": "b5e9",
	"./redvblue.png": "0680",
	"./silver.png": "f07e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "281a";